module.exports = __webpack_public_path__ + "static/media/parts.3.693520fa.png";